export default __webpack_public_path__ + "static/effectiveness-graph-7fed58d680c68e1583a430b80889ed52.png";